import * as React from "react";

const SvgIcnFacebook = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M13 10V8.016c0-.478.103-.855.346-1.12.266-.29.702-.396 1.326-.396h.828V5h-1.688c-1.153 0-1.939.241-2.376.69-.446.456-.678 1.157-.678 2.13V10H9v1.5h1.758V19H13v-7.5h2.246l.188-1.5H13zm1-1h2.566l-.437 3.5H14V20H9.758v-7.5H8V9h1.758V7.82c0-1.214.315-2.166.962-2.83.657-.671 1.694-.99 3.092-.99H16.5v3.5h-1.828c-.366 0-.568.05-.589.072-.043.048-.083.192-.083.444V9z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnFacebook;
